import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const statusFilter = (): FilterDefinition => ({
  label: i18n.t('banking.payments.data_table.status'),
  type: 'in',
  options: {
    options: [
      { value: 'pending', label: i18n.t('finance.overview.payments.requires_attention') },
      { value: 'in_progress', label: i18n.t('banking.payments.statuses.in_progress') },
      { value: 'paid', label: i18n.t('banking.payments.statuses.paid') },
    ],
  },
})

/**
 * Expands filter status values to include related statuses:
 * - 'pending' -> ['init', 'pending_consent', 'partially_paid', 'rejected', 'rejected_consent']
 * - 'paid' -> ['done', 'paid']
 */
export const expandStatusFilter = (statuses: string[]): string[] => {
  const expanded: string[] = []

  for (const status of statuses) {
    switch (status) {
      case 'pending':
        expanded.push('init', 'pending_consent', 'partially_paid', 'rejected', 'rejected_consent')
        break
      case 'paid':
        expanded.push('done', 'paid')
        break
      default:
        expanded.push(status)
    }
  }

  return expanded
}
